import React from 'react';

const STATS = [
    { count: 80, suffix: '+', label: 'advisors' },
    { count: 40, suffix: '+', label: 'VCs' },
    { count: 60, prefix: '~', suffix: '%', label: 'AI auto-fill' },
    { count: 0, prefix: '£', label: 'cost to you', pink: true },
];

const FractionalStatBand = () => (
    <section className="lp-stats">
        <div className="lp-stats-grid">
            {STATS.map((s, i) => (
                <div key={i} data-lp-reveal data-lp-delay={i * 80}>
                    <div className={`lp-stat-num ${s.pink ? 'pink' : ''}`} data-count={s.count} data-prefix={s.prefix || ''} data-suffix={s.suffix || ''}>
                        {(s.prefix || '') + s.count + (s.suffix || '')}
                    </div>
                    <div className="lp-stat-label">{s.label}</div>
                </div>
            ))}
        </div>
    </section>
);

export default FractionalStatBand;
